import type { Invitation } from '@debtbot/shared';
import { useT } from '../i18n';
import { copyText } from '../lib/clipboard';
import { inviteLink, inviteMessage } from '../lib/invite-share';
import { Button } from './Button';
import { Sheet } from './Sheet';
import { useToast } from './Toast';

/** Запасной путь, когда системный шаринг Telegram недоступен: ссылка и «Скопировать». */
export function InviteLinkSheet({
  invite,
  text,
  onClose,
}: {
  invite: Invitation | null;
  /** Сообщение к ссылке — то же, что ушло бы в share-sheet. */
  text: string;
  onClose: () => void;
}) {
  const t = useT();
  const toast = useToast();
  const link = invite ? inviteLink(invite) : '';

  const copy = async () => {
    const ok = await copyText(inviteMessage(text, link));
    toast({ text: ok ? t.home.copied : t.home.copyFailed });
    if (ok) onClose();
  };

  return (
    <Sheet open={invite !== null} onClose={onClose} title={t.home.linkTitle}>
      <p className="mb-3 text-sm text-hint">{text}</p>
      <p
        data-testid="invite-link"
        className="mb-4 select-all break-all rounded-xl bg-secondary-bg px-4 py-3 text-sm"
      >
        {link}
      </p>
      <Button data-testid="invite-copy" onClick={() => void copy()}>
        {t.home.copy}
      </Button>
    </Sheet>
  );
}
